import React, { useState , useEffect} from "react";
import { Box, Grid, TextField, MenuItem, Checkbox, FormControlLabel, Button, Typography, FormHelperText, FormControl, Select, InputLabel, Link, Divider, Paper ,Modal } from "@mui/material";
import { useLocation } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import Check from '@mui/icons-material/Check';
import Auth from "../Auth/Auth";
import { getUserByEmail, getUserById, validateUser } from "../../services/userProfileService";
import LoginPopup from "../Login/LoginPopup";
const countries = [
  { code: "IN", name: "India" },
  { code: "US", name: "United States" },
  { code: "UK", name: "United Kingdom" },
];

const INTERNAL_LOGIN_TYPE_ID = 1;

const AccountDetailsForm = ({ active, onContinue, onEdit, isUpgrade = false }) => {
  const location = useLocation();
  const {isLoggedIn } = Auth();
  const selectedPlan = location.state.plan;
  const [openPopup, setOpenPopup] = useState(false);
  const [loginPopupOpen, setLoginPopupOpen] = useState(false);


  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    confirmEmail: "",
    country: "",
    agree: false,
  });

  useEffect(() => {
    const userId = localStorage.getItem("user_id");
    if (!userId) return;

    getUserById(userId)
      .then((user) => {
        if (user) {
          const populated = {
            firstName: user.first_name || "",
            lastName: user.last_name || "",
            email: user.email || "",
            confirmEmail: isUpgrade ? (user.email || "") : "",
            country: user.country || "IN",
            agree: isUpgrade ? true : false,
            emailReadonly: true,
          };
          setFormData(populated);
          if (isUpgrade) {
            onContinue({ ...populated, INTERNAL_LOGIN_TYPE_ID });
          }
        }
      })
      .catch((err) => console.error("Error fetching user details:", err));
  }, [isUpgrade]);

  const [error, setError] = useState("");

  // if (!active) {
  //   return (
  //     <Paper sx={{ p: 4, borderRadius: 2 , mb:2}}>
  //     <Typography variant="h3" fontWeight="bold" gutterBottom> Account details{" "} <Check sx={{ color: "success.main", fontSize: "2rem", verticalAlign: "middle" }}/> </Typography>
  //     </Paper>
  //   );
  // }
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (formData.email !== formData.confirmEmail) {
      setError("Emails do not match");
      return;
    }
    setError("");
    let userId;
    if (!isLoggedIn) {
      try {
        const emailResponse = await getUserByEmail(formData.email);
        if (emailResponse.exists) {
          setOpenPopup(true);
          return;
        } 
        // else {
        //   const user = {
        //     email: formData.email,
        //     login_type_id: INTERNAL_LOGIN_TYPE_ID,
        //     first_name: formData.firstName,
        //     last_name: formData.lastName
        //   };
        //   const response = await validateUser(user);
        //   if (response.success == true) {
        //     userId = response.user_id; 
        //     console.log("user added succesfully" , response)
        //   }
        // }
      } catch (err) {
        console.error("Error checking email:", err);
      }
    }
    onContinue({...formData , INTERNAL_LOGIN_TYPE_ID});
  };

  const handleLoginClick = () => {
    setLoginPopupOpen(true);
  };

  return (
    <>
    {/* <Paper sx={{ p: 4, borderRadius: 2 , mb:2}}> */}
      {/* <Typography variant="h3" fontWeight="bold" gutterBottom sx={{mb:3}}> Account details </Typography> */}
      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
               id="outlined-basic"
              label="First name"
              name="firstName"
              value={formData.firstName}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" , shrink: true} }}
              InputProps={{ readOnly: isUpgrade }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Last name"
              name="lastName"
              value={formData.lastName}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              InputProps={{ style: { color: "white" }, readOnly: isUpgrade }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Email"
              name="email"
              type="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
              required
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              InputProps={{ style: { color: "white" }, readOnly: isUpgrade || formData.emailReadonly || false }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              label="Confirm Email"
              name="confirmEmail"
              type="email"
              value={formData.confirmEmail}
              onChange={handleChange}
              fullWidth
              required
              error={!!error}
              helperText={error}
              variant="outlined"
              InputLabelProps={{ style: { color: "#aaa" } }}
              InputProps={{ style: { color: "white" }, readOnly: isUpgrade }}
            />
          </Grid>

          <Grid size={{ xs: 12, sm: 6 }}>
            <TextField
              id="outlined-select-country"
              placeholder="select-country"
              select
              label="Country"
              name="country"
              value={formData.country}
              defaultValue={"India"}
              onChange={isUpgrade ? undefined : handleChange}
              fullWidth
              variant="outlined"
              helperText="Please select your country"
              inputProps={{ readOnly: isUpgrade }}
            >
              {countries.map((option) => (
                <MenuItem key={option.code} value={option.code}>{option.name}</MenuItem>
              ))}
            </TextField>
          </Grid>

          <Grid size={{ xs: 12 }}>
            <Divider sx={{ mb: 1 }} />
            <FormControlLabel
              control={
                <Checkbox name="agree" checked={formData.agree} onChange={handleChange} disabled={isUpgrade} />
              }
              label={
                <Typography variant="body2" >
                  By checking here and continuing, I agree to the{" "}
                  <Link href="#" onClick={(e) => e.preventDefault()} style={{ textDecoration: "underline" }} >Terms of Use</Link>. *
                </Typography>
              }
            />
          </Grid>

          {!isUpgrade && (
          <Grid size={{ xs: 12 }}>
            <Button type="submit" variant="contained" fullWidth disabled={!formData.agree}>Save & Continue </Button>
          </Grid>
          )}
        </Grid>
      </form>
    {/* </Paper> */}
     <Modal open={openPopup} disableEscapeKeyDown>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "background.paper",
          boxShadow: 24,
          p: 4,
          borderRadius: 2,
          textAlign: "center",
          minWidth: 300,
        }}
      >
        <Typography variant="h6" fontWeight="bold" gutterBottom>
          User already registered
        </Typography>
        <Typography variant="body2" sx={{ mb: 3 }}>
          Please click here to login
        </Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={handleLoginClick}
          fullWidth
        >
          Login
        </Button>
      </Box>
    </Modal>
     <LoginPopup open={loginPopupOpen} onClose={() => setLoginPopupOpen(false)} />
    </>
  );
};

export default AccountDetailsForm;
